import { useRef } from 'react';

import cn from 'classnames';

import { useInt } from 'hooks/useInt';
import { useIntersection } from 'hooks/useIntersection';

import { Button } from 'ui/atoms/Button/Button';
import { Icon } from 'ui/atoms/Icon/Icon';

export const CustomError = ({ statusCode }: { statusCode: number | string }) => {
  const ref = useRef<HTMLDivElement>(null);
  const intersected = useIntersection(ref);
  const { t } = useInt();

  return (
    <div className="custom-error">
      <div ref={ref} className={cn('error-bg-rectangles', intersected && 'intersected')} />

      <Icon type={[404, 500].includes(Number(statusCode)) ? statusCode.toString() : '500'} />

      <span>
        {statusCode === 404
          ? t('Oops! 404 Error – Page Not Found. The page you’re looking for doesn’t exist.')
          : t("We're sorry, but something went wrong.")}
      </span>

      <Button size="xxl" href={`${process.env.HOST || ''}/`}>
        {t('Go to homepage')}
      </Button>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CustomError;
